import { render, staticRenderFns } from "./patientIntegrationDetail.vue?vue&type=template&id=a23e1374&scoped=true"
import script from "./patientIntegrationDetail.vue?vue&type=script&lang=js"
export * from "./patientIntegrationDetail.vue?vue&type=script&lang=js"
import style0 from "./patientIntegrationDetail.vue?vue&type=style&index=0&id=a23e1374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e1374",
  null
  
)

export default component.exports